import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../index';
import { verifyPhoneCloseModalAction, verifyPhoneSetErrorMessageAction } from '@cian/sms-validation-widget';
import { trackCloseSmsPopup } from '../../components/demand/utils/tracking';
import { ICreateMessageForOfferRequest } from '../../repositories/demand/v2/create-message-for-offer';
import { demandLastRequestedData } from '@cian/demand-trap-widget';

export const verifyPhoneCloseModal = (): ThunkAction<void, IState, IContext> => {
  return async (dispatch, getState) => {
    const state = getState();
    const demandData: ICreateMessageForOfferRequest = demandLastRequestedData(state);
    dispatch(verifyPhoneSetErrorMessageAction(''));
    dispatch(verifyPhoneCloseModalAction());
    trackCloseSmsPopup(Boolean(demandData.isHomeowner));
  };
};
